export enum ApplicationPricingTypeModel {
  CHILD = 'child',
  ADULT = 'adult',
  ROOM = 'room',
  PERSON = 'person',
}
